// extracted by mini-css-extract-plugin
export default {"container":"style_container__kFmQv","overlay":"style_overlay__mga-M","playControls":"style_playControls__kFdTu"};